import React, { Fragment, useState, useContext } from "react";
import { Card, CardText, Row, Col, CardBody } from "reactstrap";
import { Input, Icon, Button } from "semantic-ui-react";
import { GlobalContext } from "../context/GlobalState";
import { CardNoData } from "./Cards/noData";
import { Redirect } from "react-router-dom";
import OBLLogo from "./resources/logo_obl.png";
import imagenLogin from "./resources/Imagen_Login_basic.png";
import { Services } from "./Services";
import { PublicAccessRepository } from "../repositories";

const BackgroundHead = {
  backgroundImage: "url(" + imagenLogin + ")",
  backgroundSize: "cover",
};

export const Search = () => {
  const { results, Results, ResultsList, SearchParam } =
    useContext(GlobalContext);
  const [searchValue, setSearchValue] = useState("");
  const [redirect, setRedirect] = useState(false);

  async function busqueda() {
    // let url = `${Services.PublicAccess.path}search?filter=${searchValue}`
    // let tracking = await Axios.get(url);
    const tracking = await PublicAccessRepository.getSearch(searchValue);
    SearchParam(searchValue);
    let valid;
    if (tracking.data.length > 0 && tracking.data.length < 2) {
      ResultsList(tracking.data);
    }

    if (tracking.data.length >= 2) {
      valid = false;
      ResultsList(tracking.data);
      setRedirect(true);
    } else {
      valid = true;
    }

    Results(valid);
  }

  return (
    <Fragment>
      <div style={BackgroundHead}>
        <div className="container-login">
          {redirect ? <Redirect to="/results" /> : ""}
          <Col xs={12} md={8} lg={9} className="ml-auto mr-auto">
            {results ? (
              <CardNoData />
            ) : (
              <Card>
                <CardBody>
                  <img
                    src={OBLLogo}
                    alt="OBL Logo"
                    style={{ width: "25%", display: "inline" }}
                  />{" "}
                  <b className="tag-custom-value-title ">SHIPMENT TRACKING</b>
                  <hr className="hr-style mt-2 mb-5" />
                  <CardText>
                    <CardBody>
                      <Row className="d-flex align-items-center">
                        <Col
                          xs="12"
                          md="3"
                          lg="3"
                          className="d-flex justify-content-center"
                        >
                          <span className="title-custom-value">
                            Write your reference number:
                          </span>
                        </Col>
                        <Col xs="12" md="7" lg="7">
                          <Input
                            fluid
                            placeholder="Shipment No., Customer ref, Container No., HBL/HAWB"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                          />
                        </Col>
                        <Col xs="12" md="2" lg="2">
                          <Button
                            fluid
                            color="blue"
                            // style={{ background: "#0060a8", color: "white" }}
                            onClick={() => {
                              busqueda();
                            }}
                          >
                            Track
                          </Button>
                        </Col>
                      </Row>
                    </CardBody>
                    <Col xs={12} className="mt-5">
                      <Row
                        className="d-flex align-items-center background-row"
                        style={{ height: "70px" }}
                      >
                        <Col sm="2" md="3">
                          <center>
                            <Icon
                              name="calendar alternate outline"
                              size="big"
                            />
                          </center>
                        </Col>
                        <Col
                          sm="9"
                          // style={{ marginTop: "10px", height: '70px' }}
                        >
                          <p>
                            Note: <br /> You can search for shipments made in
                            the last 120 days.
                          </p>
                        </Col>
                        <br />
                      </Row>
                    </Col>
                  </CardText>
                </CardBody>
              </Card>
            )}
          </Col>
        </div>
      </div>
    </Fragment>
  );
};
